export default Object.freeze({
  DONACION: 1,
  AUXILIAR: 2,
});
